import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { handleAccordian } from './vishwakarmaJs';

import Header from './component/header';
import Footer from './component/footer';
import Splash from './component/Splash';
import Profile from './component/Profile';
import Product from './component/Product';
import SearchData from './component/SearchData';
import ContextProvider from './component/utils';

import Testimonial from './component/Testimonial';
import Infrastructure from './component/Infrastructure';
import Quality from './component/Quantity';
import ContactUs from './component/ContactUs';
import DistributerEnquiry from './component/DistributerEnquiry';
import CorporateBrochure from './component/CorporateBrochure';
import CorporatePresentation from './component/CorporatePresentation';
import Certificate from './component/Certificate';
import Gallery from './component/Gallery';
import Award from './component/Award';
import GalleryDetail from './component/GalleryDetail';
import AwardDetail from './component/AwardDetail';

function App() {

  useEffect(() => {
    handleAccordian();
  }, []);

  return (
    <ContextProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Splash />}></Route>
          <Route path='/Splash' element={<Splash />}></Route>
          <Route path='/Profile' element={<Profile />}></Route>
          <Route path='/Product/:productCategory' element={<Product />}></Route>
          <Route path='/Testimonial' element={<Testimonial />} />
          <Route path='/Infrastructure' element={<Infrastructure />} />
          <Route path='/Quality' element={<Quality />} />
          <Route path='/ContactUs' element={<ContactUs />} />
          <Route path='/DistributerEnquiry' element={<DistributerEnquiry />} />
          <Route path='/CorporateBrochure' element={<CorporateBrochure />} />
          <Route path='/CorporatePresentation' element={<CorporatePresentation />} />
          <Route path='/Search' element={<SearchData />} />
          <Route path='/Certificate' element={<Certificate />} />
          <Route path='/Gallery' element={<Gallery />} />
          <Route path='/GalleryDetail' element={<GalleryDetail />} />
          <Route path='/Award' element={<Award />} />
          <Route path='/AwardDetail' element={<AwardDetail />} />

                    
        </Routes>
        <Footer />
      </BrowserRouter>
    </ContextProvider>
  );
}

export default App;
